
export const getVideo = () => import('twilio-video');
